import styled from "styled-components";
import { IMAGES } from "../../../constants/images";

const Contacts = () => {
  return (
    <StyledContacts>
      <div className="contact-item">
        <span>Contact us:</span>
        <a href="mailto:info@hoze-solutions.com" className="contact-styled">
          <img src={IMAGES.EMAIL} alt="email" />
          <span> info@hoze-solutions.com </span>
        </a>
      </div>
      <div className="contact-item">
        <span>Schedule a meeting:</span>
        <a href={"https://calendly.com/martin-hofmann-hoze-solutions"} className="contact-styled" target="_blank" rel="noreferrer">
          <img src={IMAGES.CALENDAR} alt="calendar" />
          <span>Calendly</span>
        </a>
      </div>
    </StyledContacts>
  );
};

const StyledContacts = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 10px;

  .contact-item {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .contact-styled {
    display: flex;
    align-items: center;
    gap: 5px;
    text-decoration: none;
    color: inherit;
    border: 1px solid #0000ff;
    border-radius: 100px;
    padding: 2px 6px;
    color: #0000ff;
    font-weight: bold;
  }
`;

export default Contacts;
